import { SvgIcon, SvgIconProps } from '@mui/material';

export function MinusIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Icon">
          <path
            id="Vector"
            d="M14.25 8.25391H3.75C3.55109 8.25391 3.36032 8.33292 3.21967 8.47358C3.07902 8.61423 3 8.80499 3 9.00391C3 9.20282 3.07902 9.39358 3.21967 9.53424C3.36032 9.67489 3.55109 9.75391 3.75 9.75391H14.25C14.4489 9.75391 14.6397 9.67489 14.7803 9.53424C14.921 9.39358 15 9.20282 15 9.00391C15 8.80499 14.921 8.61423 14.7803 8.47358C14.6397 8.33292 14.4489 8.25391 14.25 8.25391Z"
            fill="currentcolor"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}
